import { Select } from "antd"

interface CartQuantitySelectProps {
  maxNumber: number
  qtyChange: any
  disabled: boolean
  quantity: number
  moreThen: boolean
}

const { Option } = Select

const CartQuantitySelect = ({ maxNumber, qtyChange, disabled, quantity, moreThen }: CartQuantitySelectProps) => {
  const options = Array.from({ length: maxNumber + 1 }, (_, i) => ({
    value: i.toString(),
    label: i == 0 ? `${i}(Delete)` : (i == maxNumber && moreThen) ? '50(Max)' : i.toString(),
  }))

  return (
    <Select value={quantity} placeholder="Select a number" style={{ width: "100%" }} onChange={qtyChange} disabled={disabled} >
      {options.map(option => (
        <Option key={option.value} value={option.value}>
          {option.label}
        </Option>
      ))}
    </Select>
  )
}

export default CartQuantitySelect
